module.exports = __webpack_public_path__ + "static/media/Lichen.f98303d9.webp";